"use client";

import { useState } from "react";

type FormErrorsState = Record<string, string>;

type UseFormErrorsReturn = {
  formErrors: FormErrorsState;
  setFormErrors: React.Dispatch<React.SetStateAction<FormErrorsState>>;
  addError: (field: string, message: string) => void;
  removeError: (field: string) => void;
  clearErrors: () => void;
  hasError: (field: string) => boolean;
};

/**
 * Hook para gerenciar erros de formulário
 */
export const useFormErrors = (): UseFormErrorsReturn => {
  const [formErrors, setFormErrors] = useState<FormErrorsState>({});

  const addError = (field: string, message: string) => {
    setFormErrors((prev) => ({
      ...prev,
      [field]: message,
    }));
  };

  const removeError = (field: string) => {
    setFormErrors((prev) => {
      const newErrors = { ...prev };
      delete newErrors[field];
      return newErrors;
    });
  };

  const clearErrors = () => {
    setFormErrors({});
  };

  const hasError = (field: string): boolean => {
    return !!formErrors[field];
  };

  return {
    formErrors,
    setFormErrors,
    addError,
    removeError,
    clearErrors,
    hasError,
  };
};
